{
  "menu": {
    "about": "معلومات عنا",
    "facilities": "المرافق",
    "villas": "الفيلات والأسعار",
    "allRooms": "جميع الغرف",
    "experiences": "أشياء للقيام بها",
    "gallery": "صالة العرض",
    "news": "الأخبار",
    "contact": "اتصل بنا",
    "dining": "طعام",
    "spa": "منتجع صحي"
  },
  "cta": {
    "book": "احجز الآن",
    "contact": "اتصل بنا",
    "back_to_home": "العودة للصفحة الرئيسية",
    "read_more": "اقرأ المزيد"
  },
  "home": {
    "culture": {
      "subtitle": "التراث البالي الأصيل",
      "title": "تجارب ثقافية",
      "desc": "انغمس في التراث الروحي والثقافي الغني لبالي. من طقوس تنقية المياه المقدسة إلى استكشاف التقاليد القديمة، نرشدك في رحلة لاكتشاف الروح الحقيقية للجزيرة.",
      "journeySub": "رحلة روحية",
      "journeyTitle": "تطهير سيديمين",
      "journeyDesc": "جرب طقوس تنقية المياه البالية التقليدية (ميلوكات) في ينابيع سيديمين المقدسة، المصممة لتطهير جسدك وعقلك وروحك.",
      "btnReserve": "حجز"
    },
    "activities": {
      "subtitle": "لحظات منسقة",
      "title": "أشياء للقيام بها",
      "desc": "نحن نقدم أرقى الأنشطة المنسقة لخلق ذكريات لا تُنسى أثناء إقامتك. انغمس في سحر بالي، من المغامرات المثيرة إلى الاستكشافات الثقافية العميقة والعافية الروحية.",
      "btnView": "عرض الأنشطة",
      "btnReserve": "حجز"
    },
    "different": {
      "subtitle": "باتال كيكيان سيديمين",
      "title": "ما الذي يجعلنا مختلفين",
      "desc": "اكتشف الجوهر الحقيقي للجوهرة الخفية. بعيداً عن الزحام، نقدم ملاذاً منعزلاً حيث تم تصميم كل التفاصيل لمساعدتك على الانفصال عن الواقع وتجديد نشاطك والمغادرة بذكريات جميلة تدوم مدى الحياة.",
      "card1": {
        "sub": "ملاذ خاص بعيداً عن العالم",
        "title": "جوهرة سيديمين الخفية",
        "desc": "توفر الفيلا الخاصة بنا أقصى درجات التفرد والخصوصية، بعيداً عن الشوارع المزدحمة. هنا، لست مجرد ضيف، بل مسافر متميز يختبر الهدوء البكر لبالي الأصيلة."
      },
      "card2": {
        "sub": "أيقظ حواسك وجدد روحك",
        "title": "طاقة متجددة",
        "desc": "استنشق الهواء النقي من حدائقنا الاستوائية المورقة وحقول الأرز الشاسعة. تم تصميم كل لحظة تقضيها في محيطنا الهادئ لتجديد عقلك وجسدك وروحك."
      },
      "card3": {
        "sub": "لحظات ستعتز بها إلى الأبد",
        "title": "ذكريات جميلة",
        "desc": "من الابتسامات الصادقة إلى التجارب المحلية الأصيلة، نصنع كل تفاصيل إقامتك بعناية حقيقية. عُد إلى المنزل ليس فقط وقد حصلت على الراحة، ولكن بقصص جميلة لا تُنسى لترويها."
      }
    },
    "booking": {
      "title": "هل أنت مستعد لتجربة باتال كيكيان؟",
      "desc": "تحقق من التوافر وتأكد من حجز ملاذك الخاص اليوم."
    },
    "contact": {
      "subtitle": "اتصال",
      "title": "كيف تصل إلينا",
      "desc": "سواء كان لديك سؤال حول غرفنا، أو كنت بحاجة إلى مساعدة في الحجز، أو كان لديك طلب خاص لإقامتك القادمة، فإن فريق الكونسيرج المخصص لدينا هنا لمساعدتك.",
      "btnEmail": "أرسل بريداً إلكترونياً",
      "btnWa": "راسلنا على واتساب"
    },
    "hero": {
      "subtitle": "مرحباً بكم في فيلات باتال كيكيان",
      "title": "استيقظ على المشهد البانورامي الأكثر روعة في بالي",
      "description": "احتضن الوجود المهيب لجبل أجونج وهو يطل على مدرجات الأرز الزمردية والوديان الخضراء المورقة. هنا في أحضان سيديمين الهادئة، يمتزج هواء الجبل المنعش والهدوء البكر معاً لخلق ملاذ لا يُنسى لروحك."
    },
    "intro": {
      "quote": "\"لعقود من الزمن، ألهم الجمال الآسر لسيديمين العالم.\"",
      "p1": "في عام 1938، خلد الفنان الأسطوري والتر سبيس السحر الجذاب لهذه المنطقة من خلال تحفته، <span className=\"italic text-white\">\"صباح في إيسه.\"</span> التقطت اللوحة بشكل جميل عظمة جبل أجونج الشاهقة، ومدرجات الأرز الزمردية الخصبة، وضباب الصباح الناعم، والإيقاع الهادئ للحياة الريفية في بالي. حتى يومنا هذا، تظل رمزاً مبدعاً للروعة الطبيعية في بالي.",
      "p2": "اليوم، يتكشف نفس هذا المشهد البانورامي الخلاب أمام عينيك في فيلات باتال كيكيان.",
      "p3": "يجلب كل صباح شروق شمس مذهل يغمر جبل أجونج بضوء ذهبي، ويضيء الوديان الخضراء الواسعة ويجلب نسيماً جبلياً منعشاً. هنا، يسود الهدوء، مما يجعل الوقت يبدو وكأنه قد تباطأ.",
      "p4": "في باتال كيكيان، أنت لست مجرد مقيم في فيلا فاخرة؛ أنت تغمر نفسك في نفس المناظر الطبيعية التي أسرت الفنانين والمصورين ومحبي الطبيعة من كل ركن من أركان العالم.",
      "p5": "نحن نقدم تناغماً لا تشوبه شائبة من الفخامة الراقية والتراث الثقافي العميق والجمال الطبيعي الأصيل لسيديمين.",
      "footerQuote": "تصل لقضاء عطلة. لتغادر بذكريات ستتوق إليها إلى الأبد.",
      "footerBrand": "فيلات باتال كيكيان",
      "footerTagline": "حيث يصبح كل شروق شمس تحفة فنية"
    },
    "restaurant": {
      "subtitle": "باتال كيكيان سيديمين",
      "title": "مطعم باتال كيكيان",
      "desc": "يقع مطعمنا بجوار حوض السباحة اللامتناهي والبار الأنيق، ويقدم تجربة تناول طعام رائعة مؤطرة بإطلالات شاملة على الوديان الخضراء وحقول الأرز الشاسعة. تذوق إبداعات الطهي الرائعة بينما يوقظ النسيم العليل والمحيط الطبيعي الخلاب حواسك.",
      "callToAction": "استكشف عروض الطهي الرائعة لدينا. اكتشف تخصصاتنا المحلية والدولية من خلال عرض القائمة الخاصة بنا، أو احجز طاولتك لتجربة طعام لا تُنسى.",
      "btnMenu": "عرض القائمة",
      "btnReserve": "حجز",
      "btnTransport": "حجز نقل خاص",
      "btnTransportSub": "(منطقة سيديمين)",
      "btnMaps": "خرائط جوجل",
      "btnMapsSub": "الموقع"
    },
    "spa": {
      "subtitle": "باتال كيكيان سيديمين",
      "title": "سبا باتال كيكيان",
      "desc": "جدد شباب عقلك وجسدك وروحك في سبا باتال كيكيان. جرب طقوس الشفاء البالية الأصيلة والتدليك المريح الذي يقوم به معالجونا المهرة، كل ذلك أثناء الاستمتاع بالجمال الطبيعي الخلاب لسيديمين.",
      "callToAction": "اكتشف مجموعتنا الكاملة من العلاجات الشاملة. اعرض قائمة السبا الخاصة بنا لاستكشاف علاجاتنا المريحة، أو احجز جلسة تجديد شبابك اليوم.",
      "btnMenu": "عرض القائمة",
      "btnReserve": "حجز",
      "btnTransport": "حجز نقل خاص",
      "btnTransportSub": "(منطقة سيديمين)",
      "btnMaps": "خرائط جوجل",
      "btnMapsSub": "الموقع"
    },
    "rooms": {
      "subtitle": "باتال كيكيان سيديمين",
      "title": "فيلات باتال كيكيان",
      "desc": "تم تصميم كل فيلا بعناية كملاذ خاص لك، وتتميز بإطلالات خلابة ومتواصلة على جبل أجونج وحقول الأرز الشاسعة والوديان الخضراء المورقة، وتمزج بسلاسة بين الفخامة وصفاء الطبيعة."
    }
  },
  "about": {
    "hero": {
      "subtitle": "قصتنا",
      "title": "استيقظ على المشهد البانورامي الأكثر روعة في بالي",
      "desc": "احتضن الوجود المهيب لجبل أجونج وهو يطل على مدرجات الأرز الزمردية والوديان الخضراء المورقة. هنا في أحضان سيديمين الهادئة، يمتزج هواء الجبل المنعش والهدوء البكر معاً لخلق ملاذ لا يُنسى لروحك.",
      "btnScroll": "اقرأ القصة"
    },
    "story": {
      "p1": "تقع فيلات باتال كيكيان على حافة سيديمين، كارانجاسيم، وهي أكثر من مجرد وجهة؛ إنها دعوة لتجربة نبض قلب بالي. مع إطلالات بانورامية من أعلى التل، يبدأ كل صباح هنا بسيمفونية من الطبيعة — شروق شمس ذهبي يضيء قمة جبل أجونج الشاهقة، وتأطيرها المساحات الخضراء التي لا نهاية لها والمناظر الطبيعية البكر.",
      "p2": "نعتقد أن الرفاهية الحقيقية تكمن في الانسجام مع الطبيعة. عندما تخطو إلى ملاذنا، يغمرك هواء الجبل النقي والمنعش وشعور عميق بالهدوء. إنه مكان مصمم ليفصلك عن ضجيج العالم ويعيد اتصالك بما يهم حقاً.",
      "subtitle": "تناغم الطبيعة والثقافة",
      "p3": "تعكس فيلاتنا مزيجاً سلساً من الهندسة المعمارية البالية التقليدية والراحة الحديثة، المصممة بعناية لتكريم ثقافة سيديمين الغنية. نحن نفخر بكرم ضيافتنا الأصيلة. هنا، كل ابتسامة حقيقية، وكل خدمة يتم تقديمها بأقصى درجات الاحترام لكل من ضيوفنا وتراثنا المحلي.",
      "quote": "\"فيلات باتال كيكيان هي جنتك الخفية - مكان حيث تنسج المناظر الطبيعية المهيبة والثقافة الغنية والضيافة القلبية نسيجاً لا يُنسى من الذكريات.\"",
      "footer": "نتطلع إلى الترحيب بك في ملاذنا."
    }
  },
  "facilities": {
    "hero": {
      "subtitle": "وسائل الراحة في المنتجع",
      "title": "مرافقنا",
      "desc": "اكتشف وسائل الراحة الفاخرة لدينا والمصممة لتوفير الراحة والاسترخاء طوال إقامتك في سيديمين.",
      "btnScroll": "عرض المرافق"
    },
    "fallback": {
      "poolSub": "واحة من الصفاء",
      "poolTitle": "حمامات السباحة",
      "poolDesc1": "انغمس في مسابحنا اللامتناهية الصافية والمطلة على الحدائق الاستوائية النابضة بالحياة والوادي الخصب. سواء كنت تستمتع بسباحة صباحية، أو بوجبة فطور عائمة، أو ببساطة بالاسترخاء تحت أشعة الشمس مع كوكتيل منعش، فإن مسابحنا توفر المساحة المثالية للاسترخاء.",
      "poolDesc2": "تتوفر أيضاً مسابح غطس خاصة في فيلات مختارة لأولئك الذين يبحثون عن ملاذ حميمي.",
      "restSub": "تميز الطهي",
      "restTitle": "مطعم",
      "restDesc1": "انغمس في رحلة تذوق في مطعمنا المميز في الهواء الطلق. نحن نفخر بتقديم المأكولات البالية الأصيلة إلى جانب الأطباق العالمية المفضلة، والمصنوعة جميعاً من المكونات العضوية الطازجة من مصادر محلية.",
      "restDesc2": "استمتع بوجبة الإفطار المجانية أو عشاء رومانسي على ضوء الشموع أو شاي ما بعد الظهيرة غير الرسمي أثناء الاستمتاع بالمناظر الخلابة للطبيعة المحيطة.",
      "restBtn": "عرض المزيد",
      "spaSub": "العافية والشفاء",
      "spaTitle": "سبا فاخر",
      "spaDesc1": "جدد شباب عقلك وجسدك وروحك في ملاذ السبا الهادئ لدينا. يقدم معالجونا المحترفون، المتجذرون في تقاليد الشفاء البالية القديمة، مجموعة من العلاجات من التدليك التقليدي إلى مقشرات الجسم المنعشة وعلاجات الوجه.",
      "spaDesc2": "بصفتك ضيفاً لدينا، ستتلقى أيضاً تدليكاً مجانياً للقدمين لمدة 15 دقيقة عند الوصول لغسل إرهاق السفر على الفور.",
      "spaBtn": "عرض المزيد"
    }
  },
  "accommodation": {
    "hero": {
      "subtitle": "غرفنا",
      "title": "ملاذات الصفاء في فيلات باتال كيكيان",
      "desc": "جرب الهدوء المطلق في فيلاتنا المصممة بعناية، والتي تمزج بين الراحة الحديثة والأصالة البالية.",
      "btnScroll": "اكتشف الغرف"
    },
    "detail": {
      "loading": "جاري تحميل تفاصيل الغرفة...",
      "signature": "غرفة مميزة",
      "gallerySub": "معرض الصور",
      "galleryTitle": "معرض صور الغرفة",
      "noImages": "لا توجد صور متاحة لهذا النوع من الغرف.",
      "aboutRoom": "عن الغرفة",
      "roomSize": "مساحة الغرفة",
      "bedSize": "حجم السرير",
      "view": "الإطلالة",
      "amenities": "وسائل الراحة",
      "inclusions": "المشتملات",
      "pleaseNote": "يرجى الملاحظة",
      "roomRules": "قواعد ومعلومات الغرفة",
      "roomPolicy": "سياسة الغرفة",
      "childrenPolicies": "سياسات الأطفال",
      "childrenPolicyDesc": "يُسمح للأطفال من جميع الأعمار. يمكن للأطفال حتى سن 5 سنوات الإقامة مجانًا. يمكن للأطفال من سن 6 إلى 12 عامًا الإقامة مقابل 151.250 روبية إندونيسية لكل طفل في الليلة عند توفر سرير إضافي.",
      "babyCot": "سرير أطفال",
      "babyCotDesc": "يقيم الأطفال حتى سن عامين مجانًا عند استخدام سرير أطفال متاح.",
      "extraBed": "سرير إضافي",
      "extraBedDesc": "يقيم الأشخاص مهما كان عمرهم مقابل 302.500 روبية إندونيسية للشخص الواحد في الليلة عند استخدام سرير إضافي متاح.",
      "noSmoking": "غير مسموح بالتدخين.",
      "noPets": "الحيوانات الأليفة غير مسموح بها.",
      "reserve": "حجز",
      "directBooking": "حجز مباشر معنا",
      "bookOnBooking": "احجز على Booking.com",
      "contactConcierge": "اتصل بمسؤول الاستقبال لدينا لأسئلة الحجز والطلبات المخصصة.",
      "otherChoices": "خيارات أخرى",
      "otherRooms": "غرف أخرى قد تعجبك",
      "bookYourStay": "احجز إقامتك"
    }
  },
  "luxuryCard": {
    "discover": "اكتشف"
  },
  "rooms": {
    "deluxe-bungalow-mountain-view": {
      "title": "بنغل ديلوكس (إطلالة على الجبل)",
      "description": "يتميز هذا البنغل بمسبح لا متناهي. يحتوي هذا البنغل المكيف على مدخل خاص، ويتكون من غرفة معيشة واحدة وغرفة نوم منفصلة واحدة وحمام واحد مع دش ومجفف شعر. تم تأثيث البنغل بمكتب ومنطقة جلوس ويوفر ميني بار وآلة لصنع الشاي والقهوة وإطلالات على الحديقة. توفر الوحدة سريرًا واحدًا.",
      "view": "إطلالة على الحديقة والمسبح والجبل والمعلم والنهر",
      "roomRules": "التدخين: ممنوع التدخين. ساعات الهدوء بعد 10 مساءً. تسجيل الدخول في الساعة 2 مساءً، تسجيل المغادرة في الساعة 12 ظهرًا."
    },
    "suite-room-mountain-view": {
      "title": "غرفة جناح (إطلالة على الجبل)",
      "description": "سيحظى الضيوف بتجربة خاصة حيث يوفر هذا الجناح مسبحًا مع إطلالة. يحتوي هذا الجناح الفسيح على مدخل خاص، ويتكون أيضًا من غرفة نوم واحدة ومنطقة جلوس وحمام واحد مع دش ومجفف شعر. تتميز الوحدة بتكييف الهواء وإطلالات على الحديقة وشرفة ويتم تقديم النبيذ / الشمبانيا للضيوف. توفر الوحدة سريرًا واحدًا.",
      "view": "إطلالة على الجبل والنهر والمعلم والمسبح والحديقة",
      "roomRules": "التدخين: ممنوع التدخين. ساعات الهدوء بعد 10 مساءً. تسجيل الدخول في الساعة 2 مساءً، تسجيل المغادرة في الساعة 12 ظهرًا."
    },
    "private-pool-villa-mountain-view": {
      "title": "فيلا بمسبح خاص (إطلالة على الجبل)",
      "description": "تتميز هذه الفيلا بمسبح مع إطلالة. تحتوي هذه الفيلا المكيفة على مدخل خاص، وتتكون من غرفة معيشة واحدة وغرفة نوم منفصلة واحدة وحمام واحد مع حوض استحمام ودش. توفر الفيلا الفسيحة ميني بار وآلة لصنع الشاي والقهوة ومنطقة جلوس بالإضافة إلى شرفة تطل على الحديقة. توفر الوحدة سريرًا واحدًا.",
      "view": "إطلالة على الحديقة والمسبح والجبل والنهر",
      "roomRules": "التدخين: ممنوع التدخين. ساعات الهدوء بعد 10 مساءً. تسجيل الدخول في الساعة 2 مساءً، تسجيل المغادرة في الساعة 12 ظهرًا."
    },
    "features": {
      "Infinity Pool": "مسبح لا متناهي",
      "Mountain View": "إطلالة على الجبل",
      "Private Balcony": "شرفة خاصة",
      "Private Pool": "مسبح خاص",
      "Mount Agung View": "إطلالة على جبل أجونج",
      "Living Room": "غرفة المعيشة",
      "Nature View": "إطلالة على الطبيعة",
      "Bedroom": "غرفة نوم"
    }
  },
  "experiences": {
    "hero": {
      "subtitle": "أشياء للقيام بها",
      "title": "اصنع أفضل ذكرياتك في بالي",
      "desc": "من مغامرات الطبيعة الخلابة إلى التجارب الثقافية الغامرة، نقدم مجموعة مختارة من الأنشطة لجعل كل لحظة من عطلتك أكثر تميزاً.",
      "btnScroll": "عرض الأنشطة"
    },
    "sidebar": {
      "categories": "فئات",
      "moreActivities": "المزيد من الأنشطة"
    },
    "categories": {
      "Adventure & Nature": "مغامرة وطبيعة",
      "Culture & Art": "الثقافة والفن",
      "Wellness & Spiritual": "العافية والروحانية"
    },
    "items": {
      "ATV Adventure": {
        "title": "مغامرة الدبابات",
        "description": "جرب إثارة ركوب الدبابات عبر المناظر الطبيعية الجميلة في بالي."
      },
      "Cycling Tour": {
        "title": "جولة بالدراجة",
        "description": "اركب الدراجة عبر حقول الأرز المورقة والقرى التقليدية في جولة إرشادية."
      },
      "Rice Terrace Walking Tour": {
        "title": "جولة مشي في مدرجات الأرز",
        "description": "قم بنزهة هادئة عبر بعض مدرجات الأرز الأكثر شهرة في العالم."
      },
      "Sunrise Jeep Mount Batur": {
        "title": "شروق الشمس بجيب جبل باتور",
        "description": "شاهد شروق الشمس الخلاب من جبل باتور دون المشي في الصباح الباكر."
      },
      "Scooter Tour": {
        "title": "جولة سكوتر",
        "description": "اكتشف الجواهر الخفية في سيديمين في جولة سكوتر مثيرة بصحبة مرشد."
      },
      "Rafting": {
        "title": "تجديف",
        "description": "جرب اندفاع الأدرينالين في التجديف في المياه البيضاء أسفل نهر أيونج."
      },
      "Batur Trekking": {
        "title": "رحلة باتور",
        "description": "تنزه أعلى بركان جبل باتور النشط وشاهد شروق الشمس من القمة."
      },
      "Waterfall Tour": {
        "title": "جولة الشلال",
        "description": "قم بزيارة بعض الشلالات الأكثر روعة والمخفية في منطقة سيديمين."
      },
      "Swing": {
        "title": "أرجوحة",
        "description": "جرب الأدرينالين للتأرجح عالياً فوق وديان وغابات بالي المذهلة."
      },
      "Mount Agung Trekking": {
        "title": "رحلة جبل أجونج",
        "description": "تحدى نفسك برحلة شروق الشمس المجزية إلى أعلى قمة في بالي، جبل أجونج."
      },
      "Cooking Class": {
        "title": "فصل طبخ",
        "description": "تعلم أسرار المطبخ البالي الأصيل مع طهاتنا المحليين الخبراء."
      },
      "Silver Class": {
        "title": "فصل الفضة",
        "description": "اصنع مجوهراتك الفضية الفريدة بتوجيه من صائغي الفضة التقليديين."
      },
      "Coffee Plantation Tour": {
        "title": "جولة في مزرعة البن",
        "description": "اكتشف عملية صنع القهوة البالية التقليدية، بما في ذلك قهوة لواك الشهيرة."
      },
      "Yoga & Wellness": {
        "title": "اليوجا والعافية",
        "description": "جدد عقلك وجسدك من خلال جلسات اليوجا والعافية الموجهة لدينا."
      }
    }
  },
  "restaurant": {
    "categories": {
      "Appetizers": "المقبلات",
      "Soup": "الشوربات",
      "Pasta": "معكرونة",
      "Main Course": "الطبق الرئيسي",
      "Indonesian Food": "طعام إندونيسي",
      "Dessert": "حلويات",
      "Beverages": "مشروبات"
    },
    "hero": {
      "subtitle": "مطعم غابة الأوراق",
      "title": "رحلة طهي تهدئ الروح",
      "desc": "انغمس في إبداعات الطهي الرائعة التي تغذي الجسم ، مصحوبة بالبانوراما المهيبة لجبل أجونج...",
      "btnScroll": "عرض القائمة"
    },
    "sidebar": {
      "categories": "فئات",
      "moreCategories": "المزيد من الفئات"
    },
    "backToHome": "العودة للرئيسية"
  },
  "spa": {
    "categories": {
      "Body Massage": "مساج للجسم",
      "Specialty Treatments": "علاجات خاصة",
      "Body Scrub and Mask": "مقشر وقناع للجسم",
      "Facial Treatment": "علاج الوجه",
      "Manicure and Pedicure": "مانيكير وباديكير",
      "Spa Packages": "باقات السبا"
    },
    "hero": {
      "subtitle": "مرحبًا بكم في سبا باتال كيكيان",
      "title": "حيث يرتاح الجسد ، تعود الروح",
      "desc": "يميل السبا الخاص بنا إلى جسدك المتعب ، بينما تعانق طبيعة سيديمين المورقة قلبك المتعب...",
      "btnScroll": "عرض قائمة السبا"
    },
    "sidebar": {
      "treatments": "علاجات",
      "moreTreatments": "المزيد من العلاجات"
    },
    "backToHome": "العودة للرئيسية"
  },
  "contact": {
    "hero": {
      "subtitle": "ابقى على تواصل",
      "title": "اتصل بنا",
      "desc": "نحن هنا لمساعدتك.",
      "scroll": "اتصل بنا"
    },
    "info": {
      "title": "معلومات",
      "desc": "هل لديك سؤال أو تحتاج إلى مساعدة؟",
      "address": "Jl. Raya Sidemen, Sinduwati, بالي 80864"
    },
    "form": {
      "title": "أرسل لنا رسالة",
      "name": "الاسم",
      "email": "البريد الإلكتروني",
      "subject": "الموضوع",
      "message": "الرسالة",
      "btnSend": "إرسال رسالة",
      "btnSending": "جاري الإرسال...",
      "success": "شكرا لك! تم إرسال رسالتك.",
      "error": "عفوا! حدث خطأ ما."
    }
  },
  "faq": {
    "q1": {
      "question": "ما هو وقت تسجيل الوصول والمغادرة؟",
      "answer": "وقت تسجيل الوصول هو الساعة 2:00 مساءً، وتسجيل المغادرة هو الساعة 12:00 ظهرًا. يخضع تسجيل الوصول المبكر أو تسجيل المغادرة المتأخر للتوافر وقد يترتب عليه رسوم إضافية."
    },
    "q2": {
      "question": "هل الإفطار مشمول في سعر الغرفة؟",
      "answer": "نعم، يشمل حجز جميع الفيلات لدينا وجبة إفطار يومية مجانية."
    },
    "q3": {
      "question": "هل توفرون خدمة نقل من وإلى المطار؟",
      "answer": "نعم، نحن نقدم خدمات نقل المطار مقابل رسوم إضافية. يرجى الاتصال بنا مسبقاً لترتيب الاستقبال."
    },
    "q4": {
      "question": "هل منتجع Patal Kikian مناسب للعائلات؟",
      "answer": "بينما نرحب بالضيوف من جميع الأعمار، تم تصميم مكان الإقامة الخاص بنا كملاذ هادئ. يجب على الآباء مراقبة الأطفال في جميع الأوقات، وخاصة بالقرب من منطقة المسبح."
    },
    "q5": {
      "question": "هل تلبيون القيود الغذائية؟",
      "answer": "بالتأكيد. يمكن لمطعمنا تلبية المتطلبات الغذائية المختلفة بما في ذلك الخيارات النباتية والخالية من الغلوتين. يرجى إعلامنا باحتياجاتك قبل الوصول."
    },
    "q6": {
      "question": "هل يتوفر واي فاي في الفيلا؟",
      "answer": "نعم، تتوفر خدمة الواي فاي عالية السرعة مجانًا في جميع أنحاء مكان الإقامة، بما في ذلك جميع الغرف والمناطق العامة."
    },
    "subtitle": "معلومات",
    "title": "أسئلة مكررة",
    "stillHaveQuestions": "هل لا يزال لديك أسئلة؟",
    "btnContact": "اتصل بنا"
  },
  "terms": {
    "usage": {
      "title": "استخدام الموقع",
      "p1": "مرحبا بك في موقعنا. إذا واصلت التصفح واستخدام هذا الموقع، فأنت توافق على الالتزام بشروط وأحكام الاستخدام التالية التي تحكم مع سياسة الخصوصية علاقتك مع Patal Kikian Villas.",
      "p2": "إذا كنت لا توافق على هذه الشروط، يرجى عدم استخدام موقعنا.",
      "p3": "محتوى صفحات هذا الموقع لمعلوماتك العامة والاستخدام فقط."
    },
    "booking": {
      "title": "شروط الحجز",
      "p1_bold": "عقدك مع Patal Kikian Villas:",
      "p1": "تشكل شروط الحجز هذه أساس عقدك معنا. من خلال إجراء حجز، أنت توافق على الالتزام بهذه الشروط.",
      "p2_bold": "الدفع:",
      "p2": "في وقت الحجز سيطلب منك تقديم تفاصيل بطاقة الائتمان أو دفع وديعة. سيتم خصم رسوم عدم الحضور من البطاقة.",
      "p3_bold": "الدقة:",
      "p3": "نحن نسعى جاهدين لضمان دقة المعلومات ولكننا نحتفظ بالحق في تصحيح الأخطاء."
    },
    "cancellation": {
      "title": "سياسة الإلغاء",
      "p1_bold": "الأسعار القياسية:",
      "p1": "الإلغاءات في غضون 14 يومًا من الوصول ستتحمل رسوم ليلة واحدة. في غضون 7 أيام أو عدم الحضور سيتحمل رسوم 100٪.",
      "p2_bold": "الأسعار غير القابلة للاسترداد:",
      "p2": "لا يمكن إلغاء هذه الحجوزات بدون رسوم 100٪."
    },
    "copyright": {
      "title": "حقوق النشر",
      "p1": "هذا الموقع ومحتواه هي حقوق طبع ونشر لـ Patal Kikian Villas. جميع الحقوق محفوظة."
    },
    "subtitle": "قانوني",
    "title": "الشروط والأحكام"
  },
  "privacy": {
    "policy": {
      "title": "سياسة الخصوصية",
      "p1": "نحن نتفهم أن تزويدنا بالمعلومات الشخصية ينطوي على قدر كبير من الثقة؛ نأخذ هذه الثقة على محمل الجد. تحدد هذه السياسة كيفية حمايتنا لمعلوماتك.",
      "p2": "نحن ملتزمون بضمان حماية خصوصيتك.",
      "p3": "قد نغير هذه السياسة من وقت لآخر بتحديث هذه الصفحة."
    },
    "collect": {
      "title": "ما نجمعه",
      "p1": "قد نجمع المعلومات التالية:",
      "l1": "الاسم ومعلومات الاتصال",
      "l2": "المعلومات الديموغرافية",
      "l3": "معلومات أخرى ذات صلة",
      "l4": "عنوان IP الخاص بك"
    },
    "usage": {
      "title": "ماذا نفعل بالمعلومات",
      "p1": "نحن نطلب هذه المعلومات لتزويدك بخدمة أفضل:",
      "l1": "حفظ السجلات الداخلية.",
      "l2": "لتحسين منتجاتنا وخدماتنا.",
      "l3": "لإرسال رسائل ترويجية.",
      "l4": "لتخصيص الموقع.",
      "p2": "يمكنك إلغاء الاشتراك في أي وقت عن طريق info@patalkikianbali.com."
    },
    "security": {
      "title": "الأمان",
      "p1": "نحن ملتزمون بضمان أمان معلوماتك.",
      "p2_bold": "المعلومات المالية:",
      "p2": "نحن لا نخزن بيانات بطاقة الائتمان على خوادمنا المحلية."
    },
    "cookies": {
      "title": "كيف نستخدم ملفات تعريف الارتباط",
      "p1": "تساعد ملفات تعريف الارتباط في تحليل حركة مرور الويب. يمكنك قبول أو رفض ملفات تعريف الارتباط."
    },
    "subtitle": "قانوني",
    "title": "سياسة الخصوصية"
  },
  "footer": {
    "explore": "يكتشف",
    "information": "معلومة",
    "desc": "جرب الحياة الهادئة في سيديمين. استمتع بإطلالات خلابة على جبل أجونج والفيلات الفاخرة.",
    "translate": "ترجمة",
    "quickLinks": "روابط سريعة",
    "support": "الدعم",
    "contactTitle": "اتصال",
    "contact": "اتصال",
    "faq": "أسئلة مكررة",
    "terms": "الشروط والأحكام",
    "privacy": "سياسة الخصوصية",
    "whatsappUs": "تواصل معنا عبر واتساب",
    "allRightsReserved": "جميع الحقوق محفوظة.",
    "newsJournal": "الأخبار واليوميات"
  },
  "news": {
    "journal": "مجلة",
    "latest": "أحدث الأخبار والقصص",
    "subtitle": "ابق على اطلاع بأحدث الأخبار والقصص والأحداث حول باتال كيكيان وسيديمين.",
    "readNews": "قراءة الأخبار",
    "allArticles": "جميع المقالات",
    "noArticles": "لم يتم العثور على مقالات في هذه الفئة.",
    "page": "صفحة",
    "of": "من"
  },
  "newsSearch": {
    "searchBreadcrumb": "بحث",
    "searchResults": "نتائج البحث",
    "searchArticles": "البحث في المقالات",
    "resultsFound": "تم العثور على {{count}} نتائج",
    "forQuery": " لـ \"{{query}}\"",
    "placeholder": "البحث في المقالات...",
    "searchBtn": "بحث",
    "noResults": "لم يتم العثور على مقالات تطابق \"{{query}}\".",
    "enterKeyword": "أدخل كلمة رئيسية للبحث في المقالات.",
    "backToNews": "العودة إلى الأخبار"
  },
  "newsCategory": {
    "category": "فئة",
    "articlesInCat": "مقالات في هذه الفئة",
    "noArticles": "لم يتم العثور على مقالات في هذه الفئة.",
    "backToNews": "العودة إلى الأخبار"
  },
  "newsDetail": {
    "tags": "العلامات",
    "exclusiveStay": "إقامة حصرية",
    "promoDesc": "جرب الفخامة المميزة في سيديمين",
    "bookStay": "احجز إقامتك",
    "reserveStay": "احجز إقامتك",
    "villaRecs": "توصيات الفلل",
    "recAccommodations": "أماكن إقامة موصى بها",
    "readArticle": "قراءة المقال",
    "search": "بحث",
    "searchPlaceholder": "البحث في المقالات...",
    "go": "اذهب",
    "categories": "الفئات",
    "popularPosts": "مقالات شائعة",
    "bookNow": "احجز الآن",
    "notFound": "المقال غير موجود",
    "notFoundDesc": "المقال الإخباري الذي تبحث عنه غير موجود أو تم نقله.",
    "backToNews": "العودة إلى الأخبار"
  }
}